import {
  ActionType,
  CancelGuidedModeAction,
  FinishGuidedModeAction,
  GoToGuidedStepAction,
  NextGuidedStepAction,
  PreviousGuidedStepAction,
  StartGuidedModeAction,
} from './types';

export const startGuidedMode = (): StartGuidedModeAction => ({
  type: ActionType.startGuidedMode,
});

export const goToGuidedStep = (stepIndex: number): GoToGuidedStepAction => ({
  type: ActionType.goToGuidedStep,
  stepIndex,
});

export const nextGuidedStep = (): NextGuidedStepAction => ({
  type: ActionType.nextGuidedStep,
});

export const previousGuidedStep = (): PreviousGuidedStepAction => ({
  type: ActionType.previousGuidedStep,
});

export const finishGuidedMode = (): FinishGuidedModeAction => ({
  type: ActionType.finishGuidedMode,
});

export const cancelGuidedMode = (): CancelGuidedModeAction => ({
  type: ActionType.cancelGuidedMode,
});
